import { useQuery } from "@apollo/client";
import { gql } from "../__generated__/gql";
import { useAuth } from "../core/auth";
import { isWeb } from "../utils/user-agent";

export const GET_GUEST = gql(`
  query GetGuest {
    guest {
      uuid
      loadAddr
      area1
      area2
      area3
      area4
      lat
      lng
      source
      sourceEntered
    }
  }
`);

export const useGuestMode = () => {
  const { isLoggedIn } = useAuth();

  const { data: guestData } = useQuery(GET_GUEST, {
    skip: isWeb() ? true : false, // 웹인 경우 무시
  });

  const guest = guestData?.guest;
  const isGuestMode = !isLoggedIn && !!guest;
  const sourceEntered = guest?.sourceEntered || false;

  // 게스트 모드이면서 source를 입력한 상태
  const isGuestWithSource = isGuestMode && sourceEntered;

  return {
    isGuestMode,
    sourceEntered,
    isGuestWithSource,
    guest,
  };
};
